import { combineReducers, AnyAction, CombinedState } from 'redux';
import { DESTROY_AVAILABILITY_BLOCK_SCOPE } from '../actionTypes';
import { AdjustmentsState, AvailabilitiesState, InitState } from '../types';
import init from './init';
import adjustments from './adjustments';
import availabilities from './availabilities';

const availabilityBlockReducers = combineReducers({
    init,
    adjustments,
    availabilities,
});

export default (
    state: CombinedState<{
        init: InitState;
        adjustments: AdjustmentsState;
        availabilities: AvailabilitiesState;
    }>,
    action: AnyAction
) => {
    if (action.type === DESTROY_AVAILABILITY_BLOCK_SCOPE) {
        return availabilityBlockReducers(undefined, action);
    }

    return availabilityBlockReducers(state, action);
};
